<template>
  <!-- 项目概况 -->
  <div class="pb_content">
    <div class="race_content_body">
      <div class="raceBox">
        <div class="stepBg">
          <div class="steps">
            <div class="stepLeft" :class="steps == 0 ? 'isSteps' : ''">1</div>
            <div class="stepRightNav">
              <div>项目简介</div>
              <div>说明</div>
            </div>
            <div class="line" :class="steps == 0 ? 'isLine' : ''"></div>
          </div>
          <div class="steps">
            <div class="stepLeft" :class="steps == 1 ? 'isSteps' : ''">2</div>
            <div class="stepRightNav">
              <div>驱动问题</div>
              <div>说明</div>
            </div>
            <div class="line" :class="steps == 1 ? 'isLine' : ''"></div>
          </div>
          <div class="steps">
            <div class="stepLeft" :class="steps == 2 ? 'isSteps' : ''">3</div>
            <div class="stepRightNav">
              <div>平台案例实施（选填）</div>
              <div>平台</div>
            </div>
            <div class="line" :class="steps == 2 ? 'isLine' : ''"></div>
          </div>
          <div class="steps">
            <div class="stepLeft" :class="steps == 3 ? 'isSteps' : ''">4</div>
            <div class="stepRightNav">
              <div>案例评审</div>
              <div>评审状态、反馈</div>
            </div>
            <!-- <div class="line" :class="steps == 3 ? 'isLine' : ''"></div> -->
          </div>
        </div>
        <div class="right">
          <div class="whiteBg">
            <div class="right_title">驱动性问题</div>
            <div class="basic_box1">
              <div class="editorCss">
                <editor-bar
                  v-model="raceOver.driQuestion.brief"
                  @change="upRaceOver"
                ></editor-bar>
              </div>
              <div>
                <div class="basic_box">
                  <div class="lineBox">
                    <div class="lineTitle">附件内容</div>
                    <div class="strLine"></div>
                  </div>
                  <div>
                    <div
                      class="add_chapters_box"
                      v-if="
                        raceOver.driQuestion.data &&
                        raceOver.driQuestion.data.length == 0
                      "
                      style="height: 185px"
                    ></div>
                    <div
                      v-else
                      class="add_chapters_box"
                      style="display: flex; flex-direction: column"
                    >
                      <div
                        class="chapter_upload"
                        v-for="(item, index) in raceOver.driQuestion.data"
                        :key="item.id"
                      >
                        <div class="chapter_upload_t"></div>
                        <div class="chapter_upload_o">
                          <div class="chapter_upload_l">
                            <div
                              v-if="item.type == 2"
                              class="chapter_upload_l_i1"
                            ></div>
                            <div
                              v-if="item.type == 1 || item.type == 3"
                              class="chapter_upload_l_i5"
                            ></div>
                            <div
                              v-if="item.type == 4"
                              class="chapter_upload_l_i8"
                              style="margin-left: 1px"
                            ></div>
                          </div>
                          <div class="chapter_upload_ic">
                            <div class="chapter_upload_ic_l"></div>
                            <div
                              class="chapter_upload_ic_r"
                              @click.stop="deleteChapterData($event, index, 0)"
                            >
                              <div></div>
                            </div>
                          </div>
                          <div class="chapter_upload_n">
                            <input
                              class="first"
                              v-if="item.type == 1"
                              :placeholder="item.name"
                            />
                            <input
                              class="first"
                              v-if="item.type == 2"
                              :placeholder="item.name"
                            />
                            <input
                              class="first"
                              :placeholder="item.name"
                              v-if="item.type == 3"
                              readonly="true"
                              @click="selectAttText(0, index)"
                            />
                            <input
                              class="first"
                              v-if="item.type == 4"
                              :placeholder="item.name"
                              @click="selectLine(0, index)"
                            />
                            <div class="chapter_upload_ud">
                              <div class="chapter_upload_up"></div>
                              <div class="chapter_upload_down"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add_info_box">
                    <!-- <button class="info_btn" @click="addImg($event)">
                      添加教学视频
                      <input
                        type="file"
                        accept="video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        capture="camera"
                        @change="beforeUpload($event, 2, index, 0)"
                      />
                    </button> -->
                    <button class="info_btn" @click="addImg($event)">
                      上传附件
                      <input
                        type="file"
                        accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        @change="beforeUpload($event, null, 0)"
                      />
                    </button>
                    <!-- <button class="info_btn" @click="addAttText(0)">
                      添加图文
                    </button>
                    <button class="info_btn" @click="openLine(0)">
                      添加链接
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="whiteBg">
            <div class="right_title">目标设计</div>
            <div class="basic_box1">
              <div class="editorCss">
                <editor-bar
                  v-model="raceOver.tarDesign.brief"
                  @change="upRaceOver"
                ></editor-bar>
              </div>
              <div>
                <div class="basic_box">
                  <div class="lineBox">
                    <div class="lineTitle">附件内容</div>
                    <div class="strLine"></div>
                  </div>
                  <div>
                    <div
                      class="add_chapters_box"
                      v-if="
                        raceOver.tarDesign.data &&
                        raceOver.tarDesign.data.length == 0
                      "
                      style="height: 185px"
                    ></div>
                    <div
                      v-else
                      class="add_chapters_box"
                      style="display: flex; flex-direction: column"
                    >
                      <div
                        class="chapter_upload"
                        v-for="(item1, index1) in raceOver.tarDesign.data"
                        :key="item1.id"
                      >
                        <div class="chapter_upload_t"></div>
                        <div class="chapter_upload_o">
                          <div class="chapter_upload_l">
                            <div
                              v-if="item1.type == 2"
                              class="chapter_upload_l_i1"
                            ></div>
                            <div
                              v-if="item1.type == 1 || item1.type == 3"
                              class="chapter_upload_l_i5"
                            ></div>
                            <div
                              v-if="item1.type == 4"
                              class="chapter_upload_l_i8"
                              style="margin-left: 1px"
                            ></div>
                          </div>
                          <div class="chapter_upload_ic">
                            <div class="chapter_upload_ic_l"></div>
                            <div
                              class="chapter_upload_ic_r"
                              @click.stop="deleteChapterData($event, index1, 1)"
                            >
                              <div></div>
                            </div>
                          </div>
                          <div class="chapter_upload_n">
                            <input
                              class="first"
                              v-if="item1.type == 1"
                              :placeholder="item1.name"
                            />
                            <input
                              class="first"
                              v-if="item1.type == 2"
                              :placeholder="item1.name"
                            />
                            <input
                              class="first"
                              :placeholder="item1.name"
                              v-if="item1.type == 3"
                              readonly="true"
                              @click="selectAttText(1, index1)"
                            />
                            <input
                              class="first"
                              v-if="item1.type == 4"
                              :placeholder="item1.name"
                              @click="selectLine(1, index1)"
                            />
                            <div class="chapter_upload_ud">
                              <div class="chapter_upload_up"></div>
                              <div class="chapter_upload_down"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add_info_box">
                    <!-- <button class="info_btn" @click="addImg($event)">
                      添加教学视频
                      <input
                        type="file"
                        accept="video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        capture="camera"
                        @change="beforeUpload($event, 2, index1, 1)"
                      />
                    </button> -->
                    <button class="info_btn" @click="addImg($event)">
                      上传附件
                      <input
                        type="file"
                        accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        @change="beforeUpload($event, null, 1)"
                      />
                    </button>
                    <!-- <button class="info_btn" @click="addAttText(1)">
                      添加图文
                    </button>
                    <button class="info_btn" @click="openLine(1)">
                      添加链接
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="whiteBg">
            <div class="right_title">活动设计</div>
            <div class="basic_box1">
              <div class="editorCss">
                <editor-bar
                  v-model="raceOver.actiDesign.brief"
                  @change="upRaceOver"
                ></editor-bar>
              </div>
              <div>
                <div class="basic_box">
                  <div class="lineBox">
                    <div class="lineTitle">附件内容</div>
                    <div class="strLine"></div>
                  </div>
                  <div>
                    <div
                      class="add_chapters_box"
                      v-if="
                        raceOver.actiDesign.data &&
                        raceOver.actiDesign.data.length == 0
                      "
                      style="height: 185px"
                    ></div>
                    <div
                      v-else
                      class="add_chapters_box"
                      style="display: flex; flex-direction: column"
                    >
                      <div
                        class="chapter_upload"
                        v-for="(item2, index2) in raceOver.actiDesign.data"
                        :key="item2.id"
                      >
                        <div class="chapter_upload_t"></div>
                        <div class="chapter_upload_o">
                          <div class="chapter_upload_l">
                            <div
                              v-if="item2.type == 2"
                              class="chapter_upload_l_i1"
                            ></div>
                            <div
                              v-if="item2.type == 1 || item2.type == 3"
                              class="chapter_upload_l_i5"
                            ></div>
                            <div
                              v-if="item2.type == 4"
                              class="chapter_upload_l_i8"
                              style="margin-left: 1px"
                            ></div>
                          </div>
                          <div class="chapter_upload_ic">
                            <div class="chapter_upload_ic_l"></div>
                            <div
                              class="chapter_upload_ic_r"
                              @click.stop="deleteChapterData($event, index2, 2)"
                            >
                              <div></div>
                            </div>
                          </div>
                          <div class="chapter_upload_n">
                            <input
                              class="first"
                              v-if="item2.type == 1"
                              :placeholder="item2.name"
                            />
                            <input
                              class="first"
                              v-if="item2.type == 2"
                              :placeholder="item2.name"
                            />
                            <input
                              class="first"
                              :placeholder="item2.name"
                              v-if="item2.type == 3"
                              readonly="true"
                              @click="selectAttText(2, index2)"
                            />
                            <input
                              class="first"
                              v-if="item2.type == 4"
                              :placeholder="item2.name"
                              @click="selectLine(2, index2)"
                            />
                            <div class="chapter_upload_ud">
                              <div class="chapter_upload_up"></div>
                              <div class="chapter_upload_down"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add_info_box">
                    <!-- <button class="info_btn" @click="addImg($event)">
                      添加教学视频
                      <input
                        type="file"
                        accept="video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        capture="camera"
                        @change="beforeUpload($event, 2, index2, 2)"
                      />
                    </button> -->
                    <button class="info_btn" @click="addImg($event)">
                      上传附件
                      <input
                        type="file"
                        accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        @change="beforeUpload($event, null, 2)"
                      />
                    </button>
                    <!-- <button class="info_btn" @click="addAttText(2)">
                      添加图文
                    </button>
                    <button class="info_btn" @click="openLine(2)">
                      添加链接
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="whiteBg">
            <div class="right_title">评价设计</div>
            <div class="basic_box1">
              <div class="editorCss">
                <editor-bar
                  v-model="raceOver.evaDesign.brief"
                  @change="upRaceOver"
                ></editor-bar>
              </div>
              <div>
                <div class="basic_box">
                  <div class="lineBox">
                    <div class="lineTitle">附件内容</div>
                    <div class="strLine"></div>
                  </div>
                  <div>
                    <div
                      class="add_chapters_box"
                      v-if="
                        raceOver.evaDesign.data &&
                        raceOver.evaDesign.data.length == 0
                      "
                      style="height: 185px"
                    ></div>
                    <div
                      v-else
                      class="add_chapters_box"
                      style="display: flex; flex-direction: column"
                    >
                      <div
                        class="chapter_upload"
                        v-for="(item3, index3) in raceOver.evaDesign.data"
                        :key="item3.id"
                      >
                        <div class="chapter_upload_t"></div>
                        <div class="chapter_upload_o">
                          <div class="chapter_upload_l">
                            <div
                              v-if="item3.type == 2"
                              class="chapter_upload_l_i1"
                            ></div>
                            <div
                              v-if="item3.type == 1 || item3.type == 3"
                              class="chapter_upload_l_i5"
                            ></div>
                            <div
                              v-if="item3.type == 4"
                              class="chapter_upload_l_i8"
                              style="margin-left: 1px"
                            ></div>
                          </div>
                          <div class="chapter_upload_ic">
                            <div class="chapter_upload_ic_l"></div>
                            <div
                              class="chapter_upload_ic_r"
                              @click.stop="deleteChapterData($event, index3, 3)"
                            >
                              <div></div>
                            </div>
                          </div>
                          <div class="chapter_upload_n">
                            <input
                              class="first"
                              v-if="item3.type == 1"
                              :placeholder="item3.name"
                            />
                            <input
                              class="first"
                              v-if="item3.type == 2"
                              :placeholder="item3.name"
                            />
                            <input
                              class="first"
                              :placeholder="item3.name"
                              v-if="item3.type == 3"
                              readonly="true"
                              @click="selectAttText(3, index3)"
                            />
                            <input
                              class="first"
                              v-if="item3.type == 4"
                              :placeholder="item3.name"
                              @click="selectLine(3, index3)"
                            />
                            <div class="chapter_upload_ud">
                              <div class="chapter_upload_up"></div>
                              <div class="chapter_upload_down"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add_info_box">
                    <!-- <button class="info_btn" @click="addImg($event)">
                      添加教学视频
                      <input
                        type="file"
                        accept="video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        capture="camera"
                        @change="beforeUpload($event, 2, index3, 3)"
                      />
                    </button> -->
                    <button class="info_btn" @click="addImg($event)">
                      上传附件
                      <input
                        type="file"
                        accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        @change="beforeUpload($event, null, 3)"
                      />
                    </button>
                    <!-- <button class="info_btn" @click="addAttText(3)">
                      添加图文
                    </button>
                    <button class="info_btn" @click="openLine(3)">
                      添加链接
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="whiteBg">
            <div class="right_title">其他补充</div>
            <div class="basic_box1">
              <div class="editorCss">
                <editor-bar
                  v-model="raceOver.other.brief"
                  @input="upRaceOver"
                ></editor-bar>
              </div>
              <div>
                <div class="basic_box">
                  <div class="lineBox">
                    <div class="lineTitle">附件内容</div>
                    <div class="strLine"></div>
                  </div>
                  <div>
                    <div
                      class="add_chapters_box"
                      v-if="
                        raceOver.other.data && raceOver.other.data.length == 0
                      "
                      style="height: 185px"
                    ></div>
                    <div
                      v-else
                      class="add_chapters_box"
                      style="display: flex; flex-direction: column"
                    >
                      <div
                        class="chapter_upload"
                        v-for="(item4, index4) in raceOver.other.data"
                        :key="item4.id"
                      >
                        <div class="chapter_upload_t"></div>
                        <div class="chapter_upload_o">
                          <div class="chapter_upload_l">
                            <div
                              v-if="item4.type == 2"
                              class="chapter_upload_l_i1"
                            ></div>
                            <div
                              v-if="item4.type == 1 || item4.type == 3"
                              class="chapter_upload_l_i5"
                            ></div>
                            <div
                              v-if="item4.type == 4"
                              class="chapter_upload_l_i8"
                              style="margin-left: 1px"
                            ></div>
                          </div>
                          <div class="chapter_upload_ic">
                            <div class="chapter_upload_ic_l"></div>
                            <div
                              class="chapter_upload_ic_r"
                              @click.stop="deleteChapterData($event, index4, 4)"
                            >
                              <div></div>
                            </div>
                          </div>
                          <div class="chapter_upload_n">
                            <input
                              class="first"
                              v-if="item4.type == 1"
                              :placeholder="item4.name"
                            />
                            <input
                              class="first"
                              v-if="item4.type == 2"
                              :placeholder="item4.name"
                            />
                            <input
                              class="first"
                              :placeholder="item4.name"
                              v-if="item4.type == 3"
                              readonly="true"
                              @click="selectAttText(4, index4)"
                            />
                            <input
                              class="first"
                              v-if="item4.type == 4"
                              :placeholder="item4.name"
                              @click="selectLine(4, index4)"
                            />
                            <div class="chapter_upload_ud">
                              <div class="chapter_upload_up"></div>
                              <div class="chapter_upload_down"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="add_info_box">
                    <!-- <button class="info_btn" @click="addImg($event)">
                      添加教学视频
                      <input
                        type="file"
                        accept="video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        capture="camera"
                        @change="beforeUpload($event, 2, index4, 4)"
                      />
                    </button> -->
                    <button class="info_btn" @click="addImg($event)">
                      上传附件
                      <input
                        type="file"
                        accept="application/pdf, application/.ppt, .ppt, .pptx, .xlsx, .xls, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,video/mp4, video/quicktime, video/x-msvideo"
                        style="display: none"
                        @change="beforeUpload($event, null, 4)"
                      />
                    </button>
                    <!-- <button class="info_btn" @click="addAttText(4)">
                      添加图文
                    </button>
                    <button class="info_btn" @click="openLine(4)">
                      添加链接
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加富文本"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="500px"
      :before-close="handleClose"
      class="dialog_diy"
    >
      <el-form>
        <el-form-item label="文本标题">
          <el-input
            v-model="AttText.title"
            auto-complete="off"
            @input="change1"
            placeholder="请输入文本标题..."
          ></el-input>
        </el-form-item>
        <div>富文本内容</div>
        <editor-bar v-model="AttText.text" @change="change"></editor-bar>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearAttText">取 消</el-button>
        <el-button type="primary" @click="isAddOrUpdateAttText">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加链接"
      :visible.sync="dialogVisible1"
      :append-to-body="true"
      width="500px"
      :before-close="handleClose"
      class="dialog_diy lineCss"
    >
      <el-form>
        <el-form-item label="链接" :label-width="formLabelWidth">
          <span>
            <el-input
              placeholder="请输入链接"
              clearable
              v-model="line"
              class="add_input"
            ></el-input>
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearLine">取 消</el-button>
        <el-button type="primary" @click="isAddOrUpdateLine">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditorBar from "../../../tools/wangEnduit";
export default {
  components: { EditorBar },
  props: ["raceOverView"],
  data() {
    return {
      steps: 0,
      chapterData: [],
      formLabelWidth: "100px",
      noneBtnImg: false,
      raceOver: {
        driQuestion: { brief: "", data: [] },
        tarDesign: { brief: "", data: [] },
        actiDesign: { brief: "", data: [] },
        evaDesign: { brief: "", data: [] },
        other: { brief: "", data: [] },
      },
      AttText: {},
      task: 0,
      AttTextType: 0,
      AttTextIndex: 0,
      dialogVisible: false,
      dialogVisible1: false,
      line: "",
      lineCount: 0,
    };
  },
  methods: {
    handleClose(done) {
      done();
    },
    change(val) {
      console.log(val);
    },
    change1(val) {
      console.log(val);
      this.$forceUpdate();
    },
    addImg(e) {
      var el = e.currentTarget;
      el.getElementsByTagName("input")[0].click();
    },
    imgChange(file, fileList, type, jT) {
      if (jT == 0) {
        var _tmp = this.raceOver.driQuestion.data;
      } else if (jT == 1) {
        var _tmp = this.raceOver.tarDesign.data;
      } else if (jT == 2) {
        var _tmp = this.raceOver.actiDesign.data;
      } else if (jT == 3) {
        var _tmp = this.raceOver.evaDesign.data;
      } else {
        var _tmp = this.raceOver.other.data;
      }

      this.noneBtnImg = _tmp.length >= 1;
    },
    deleteChapterData(e, i, t) {
      e.stopPropagation();
      if (t == 0) {
        this.raceOver.driQuestion.data.splice(i, 1);
      } else if (t == 1) {
        this.raceOver.tarDesign.data.splice(i, 1);
      } else if (t == 2) {
        this.raceOver.actiDesign.data.splice(i, 1);
      } else if (t == 3) {
        this.raceOver.evaDesign.data.splice(i, 1);
      } else {
        this.raceOver.other.data.splice(i, 1);
      }
    },
    beforeUpload(event, type, jsonType) {
      const loading = this.openLoading();
      var file = event.target.files[0];
      this.inputShow = false;
      var credentials = {
        accessKeyId: "AKIATLPEDU37QV5CHLMH",
        secretAccessKey: "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",
      }; //秘钥形式的登录上传
      window.AWS.config.update(credentials);
      window.AWS.config.region = "cn-northwest-1"; //设置区域
      var type1 = type;
      var bucket = new window.AWS.S3({ params: { Bucket: "ccrb" } }); //选择桶
      var _this = this;
      var b = [
        "DOC",
        "DOCX",
        "DOCM",
        "DOTM",
        "DOTX",
        "PPTX",
        "PPSX",
        "PPT",
        "PPS",
        "PPTM",
        "POTM",
        "PPAM",
        "POTX",
        "PPSM",
      ];
      var c = ["PDF", "DOT", "DOC", "DOCX", "PPT", "PPTX", "XLSX", "XLS"];
      if (
        b.indexOf(
          file.name
            .split(".")
            [file.name.split(".").length - 1].toLocaleUpperCase()
        ) != -1
      ) {
        if (file.size / 1024 / 1024 > 10) {
          this.$message.error("上传文件大于10兆,请重新选择文件！");
          loading.close();
          return;
        }
      } else if (
        file.name
          .split(".")
          [file.name.split(".").length - 1].toLocaleUpperCase() != "PDF"
      ) {
        if (file.size / 1024 / 1024 > 5) {
          this.$message.error("添加成上传文件大于5兆,请重新选择文件！");
          loading.close();
          return;
        }
      }

      if (
        c.indexOf(
          file.name
            .split(".")
            [file.name.split(".").length - 1].toLocaleUpperCase()
        ) != -1
      ) {
        type1 = 1;
      } else {
        type1 = 2;
      }

      if (file) {
        var params = {
          Key:
            file.name.split(".")[0] +
            new Date().getTime() +
            "." +
            file.name.split(".")[file.name.split(".").length - 1],
          ContentType: file.type,
          Body: file,
          "Access-Control-Allow-Credentials": "*",
          ACL: "public-read",
        }; //key可以设置为桶的相抵路径，Body为文件， ACL最好要设置
        var options = {
          partSize: 2048 * 1024 * 1024,
          queueSize: 2,
          leavePartsOnError: true,
        };
        bucket
          .upload(params, options)
          .on("httpUploadProgress", function (evt) {
            //这里可以写进度条
            // console.log("Uploaded : " + parseInt((evt.loaded * 80) / evt.total) + '%');
          })
          .send(function (err, data) {
            loading.close();
            _this.inputShow = true;
            if (err) {
              _this.$message.error("上传失败");
            } else {
              if (jsonType == 0) {
                _this.raceOver.driQuestion.data.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type1,
                });
                _this.imgChange(null, null, type1, jsonType);
              } else if (jsonType == 1) {
                _this.raceOver.tarDesign.data.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type1,
                });
                _this.imgChange(null, null, type1, jsonType);
              } else if (jsonType == 2) {
                _this.raceOver.actiDesign.data.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type1,
                });
                _this.imgChange(null, null, type1, jsonType);
              } else if (jsonType == 3) {
                _this.raceOver.evaDesign.data.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type1,
                });
                _this.imgChange(null, null, type1, jsonType);
              } else {
                _this.raceOver.other.data.push({
                  name: file.name,
                  url: data.Location,
                  uid: file.uid,
                  type: type1,
                });
                _this.imgChange(null, null, type1, jsonType);
              }
              console.log(data.Location);
            }
          });
      }
    },
    upRaceOver() {
      this.$emit("upRaceOver", this.raceOver);
    },
    addAttText(i) {
      this.AttText = {
        title: "",
        text: "",
      };
      this.task = i;
      this.AttTextType = 0;
      this.$forceUpdate();
      this.dialogVisible = true;
    },
    clearAttText() {
      this.AttText = {
        title: "",
        text: "",
      };
      this.dialogVisible = false;
    },
    isAddOrUpdateAttText() {
      if (this.AttTextType == 0) {
        this.addAttTextMessage();
      } else {
        this.updateAttText();
      }
    },
    addAttTextMessage() {
      if (this.task == 0) {
        this.raceOver.driQuestion.data.push({
          name: this.AttText.title,
          url: this.AttText.text,
          type: 3,
        });
        this.imgChange(null, null, 3, this.task);
      } else if (this.task == 1) {
        this.raceOver.tarDesign.data.push({
          name: this.AttText.title,
          url: this.AttText.text,
          type: 3,
        });
        this.imgChange(null, null, 3, this.task);
      } else if (this.task == 2) {
        this.raceOver.actiDesign.data.push({
          name: this.AttText.title,
          url: this.AttText.text,
          type: 3,
        });
        this.imgChange(null, null, 3, this.task);
      } else if (this.task == 3) {
        this.raceOver.evaDesign.data.push({
          name: this.AttText.title,
          url: this.AttText.text,
          type: 3,
        });
        this.imgChange(null, null, 3, this.task);
      } else {
        this.raceOver.other.data.push({
          name: this.AttText.title,
          url: this.AttText.text,
          type: 3,
        });
        this.imgChange(null, null, 3, this.task);
      }
      this.dialogVisible = false;
      this.upRaceOver();
    },
    updateAttText() {
      if (this.task == 0) {
        this.raceOver.driQuestion.data[this.AttTextIndex].name =
          this.AttText.title;
        this.raceOver.driQuestion.data[this.AttTextIndex].url =
          this.AttText.text;
      } else if (this.task == 1) {
        this.raceOver.tarDesign.data[this.AttTextIndex].name =
          this.AttText.title;
        this.raceOver.tarDesign.data[this.AttTextIndex].url = this.AttText.text;
      } else if (this.task == 2) {
        this.raceOver.actiDesign.data[this.AttTextIndex].name =
          this.AttText.title;
        this.raceOver.actiDesign.data[this.AttTextIndex].url =
          this.AttText.text;
      } else if (this.task == 3) {
        this.raceOver.evaDesign.data[this.AttTextIndex].name =
          this.AttText.title;
        this.raceOver.evaDesign.data[this.AttTextIndex].url = this.AttText.text;
      } else {
        this.raceOver.other.data[this.AttTextIndex].name = this.AttText.title;
        this.raceOver.other.data[this.AttTextIndex].url = this.AttText.text;
      }
      this.dialogVisible = false;
      this.upRaceOver();
    },
    selectAttText(t, i) {
      if (t == 0) {
        this.AttText.title = this.raceOver.driQuestion.data[i].name;
        this.AttText.text = this.raceOver.driQuestion.data[i].url;
      } else if (t == 1) {
        this.AttText.title = this.raceOver.tarDesign.data[i].name;
        this.AttText.text = this.raceOver.tarDesign.data[i].url;
      } else if (t == 2) {
        this.AttText.title = this.raceOver.actiDesign.data[i].name;
        this.AttText.text = this.raceOver.actiDesign.data[i].url;
      } else if (t == 3) {
        this.AttText.title = this.raceOver.evaDesign.data[i].name;
        this.AttText.text = this.raceOver.evaDesign.data[i].url;
      } else {
        this.AttText.title = this.raceOver.other.data[i].name;
        this.AttText.text = this.raceOver.other.data[i].url;
      }
      this.task = t;
      this.AttTextIndex = i;
      this.AttTextType = 1;
      this.dialogVisible = true;
    },
    openLine(i) {
      this.line = "";
      this.task = i;
      this.lineCount = i;
      this.lineType = 0;
      this.$forceUpdate();
      this.dialogVisible1 = true;
    },
    clearLine() {
      this.line = "";
      this.dialogVisible1 = false;
    },
    isAddOrUpdateLine() {
      if (this.lineType == 0) {
        this.addLine();
      } else {
        this.updateLine();
      }
    },
    addLine() {
      if (this.task == 0) {
        this.raceOver.driQuestion.data.push({
          name: "链接",
          url: this.line,
          type: 4,
        });
        this.imgChange(null, null, 4, this.task);
      } else if (this.task == 1) {
        this.raceOver.tarDesign.data.push({
          name: "链接",
          url: this.line,
          type: 4,
        });
        this.imgChange(null, null, 4, this.task);
      } else if (this.task == 2) {
        this.raceOver.actiDesign.data.push({
          name: "链接",
          url: this.line,
          type: 4,
        });
        this.imgChange(null, null, 4, this.task);
      } else if (this.task == 3) {
        this.raceOver.evaDesign.data.push({
          name: "链接",
          url: this.line,
          type: 4,
        });
        this.imgChange(null, null, 4, this.task);
      } else {
        this.raceOver.other.data.push({
          name: "链接",
          url: this.line,
          type: 4,
        });
        this.imgChange(null, null, 4, this.task);
      }

      this.dialogVisible1 = false;
      this.upRaceOver();
    },
    updateLine() {
      if (this.task == 0) {
        this.raceOver.driQuestion.data[this.lineCount].url = this.line;
      } else if (this.task == 1) {
        this.raceOver.tarDesign.data[this.lineCount].url = this.line;
      } else if (this.task == 2) {
        this.raceOver.actiDesign.data[this.lineCount].url = this.line;
      } else if (this.task == 3) {
        this.raceOver.evaDesign.data[this.lineCount].url = this.line;
      } else {
        this.raceOver.other.data[this.lineCount].url = this.line;
      }
      this.dialogVisible1 = false;
      this.upRaceOver();
    },
    selectLine(t, i) {
      if (t == 0) {
        this.line = this.raceOver.driQuestion.data[i].url;
      } else if (t == 1) {
        this.line = this.raceOver.tarDesign.data[i].url;
      } else if (t == 2) {
        this.line = this.raceOver.actiDesign.data[i].url;
      } else if (t == 3) {
        this.line = this.raceOver.evaDesign.data[i].url;
      } else {
        this.line = this.raceOver.other.data[i].url;
      }
      this.task = t;
      this.lineCount = i;
      this.lineType = 1;
      this.dialogVisible1 = true;
    },
  },
  created() {
    this.raceOver.driQuestion = this.raceOverView.driQuestion;
    this.raceOver.tarDesign = this.raceOverView.tarDesign;
    this.raceOver.actiDesign = this.raceOverView.actiDesign;
    this.raceOver.evaDesign = this.raceOverView.evaDesign;
    this.raceOver.other = this.raceOverView.other;
  },
};
</script>

<style scoped>
.dialog_diy >>> .el-dialog__header {
  background: #3c3c3c !important;
  padding: 15px 20px;
}
.dialog_diy >>> .el-dialog__title {
  color: #fff;
}
.pb_content {
  width: 100%;
  height: 100%;
}
.race_content_body {
  width: 100%;
  position: relative;
  margin: 0;
  height: 100%;
}

.raceBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.stepBg {
  margin: 0 25px 0 0;
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  background: #fff;
  /* min-height: 800px; */
  height: 100%;
  border: 1px solid #c2c2c2;
  border-radius: 15px;
  overflow: auto;
  min-width: 260px;
}

.steps {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 35px 20px 20px 20px;
  position: relative;
}

.stepLeft,
.isSteps {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  border: 2px solid #eee;
  color: #c0c0c0;
}

.isSteps {
  background: #1990ff;
  color: #fff;
  border: none;
}

.stepRightNav {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 10px;
}

.line,
.isLine {
  position: absolute;
  width: 5px;
  height: 50px;
  border-left: 1px solid #dadada;
  top: 38px;
  left: 15px;
}

.isLine {
  border-left: 1px solid #1d92ff !important;
}

.right {
  width: calc(100% - 20%);
  background: rgb(255, 255, 255);
  border-radius: 10px;
  overflow: auto;
  height: 100%;
  border: 1px solid #c2c2c2;
  border-radius: 15px;
  /* max-height: 800px; */
  min-width: calc(100% - 260px);
}

.allBox {
  padding: 25px;
}

.allBox > div:nth-child(1) {
  color: #0f40f5;
  font-size: 18px;
  font-weight: bold;
}

.raceTop > div:nth-child(2) {
  width: 80%;
  margin-top: 10px;
}

.titleTop {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
}

.titleTop > div:nth-child(2) {
  width: 82%;
  margin-left: 20px;
}

.editorCss {
  width: 90% !important;
}

.basic_box {
  position: relative;
  margin: 0;
  min-height: 0;
  width: 90%;
}
.basic_box1 {
  margin: 10px auto;
  position: relative;
  padding: 0 20px 0 20px;
}
.add_info_box {
  margin: 20px 0;
}

.add_info_box button {
  margin: 0 10px 10px 0;
}

.add_chapters_box {
  text-align: left;
  background-color: rgb(232 234 237);
  width: 100%;
  padding: 0px 15px;
  border-radius: 15px;
  font-size: 16px;
  box-sizing: border-box;
  position: relative;
  padding: 0 10px 5px 10px;
  height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
}

.chapter_upload {
  height: 50px;
  margin-top: 12px;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 50px;
}

.chapter_upload_t {
  background-color: #fff;
  position: absolute;
  height: 100%;
  top: 0px;
  left: 0px;
  border-radius: 40px;
  box-sizing: border-box;
  box-shadow: 0 0 3px 3px #dfdfdf;
  width: 100%;
}

.chapter_upload_o {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.chapter_upload_ic {
  height: 30px;
  float: right;
  cursor: pointer;
  position: absolute;
  width: 45px;
  right: 0;
  top: 0;
}

.chapter_upload_ic_l {
  width: 50px;
  height: 50px;
  float: left;
}

.chapter_upload_ic_l div {
  width: 30px;
  height: 35px;
  background: url("../../../../assets/icon/icon.png");
}

.chapter_upload_ic_r {
  width: 50px;
  height: 50px;
  float: left;
  margin-left: 0px;
  display: flex;
  align-items: center;
  position: absolute;
}

.chapter_upload_ic_r div {
  width: 25px;
  height: 25px;
  background-image: url("../../../../assets/delete.png");
  background-size: 100% 100%;
}

.chapter_upload_n {
  display: flex;
  text-indent: 10px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 55%;
  margin-left: 10px;
  cursor: pointer;
  margin-top: 2px;
}

.chapter_upload_l_i1 {
  background-image: url("../../../../assets/icon/video.png");
  width: 28px;
  height: 28px;
  background-size: 100% 100%;
}

.chapter_upload_l_i5 {
  background-image: url("../../../../assets/icon/word.png");
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  margin-left: 1px;
}

.chapter_upload_l_i8 {
  background-image: url("../../../../assets/icon/line.png");
  width: 24px;
  height: 24px;
  background-size: 100% 100%;
  margin-left: 1px;
}

.chapter_upload_ud {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  justify-content: center;
  z-index: 99;
}

.chapter_upload_up {
  background-image: url("../../../../assets/icon/up.png");
  width: 17px;
  height: 15px;
  background-size: 100% 100%;
  cursor: pointer;
}

.chapter_upload_down {
  background-image: url("../../../../assets/icon/down.png");
  width: 17px;
  height: 15px;
  margin: 2px auto 0 auto;
  background-size: 100% 100%;
  cursor: pointer;
}

.chapter_upload_l {
  padding: 1px 0 0 10px;
}

.first {
  border: none;
  outline: none;
  width: 80%;
  min-width: 215px;
  z-index: 99;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info_btn {
  color: #fff;
  background-color: #0f7eff;
  padding: 8px 24px;
  font-size: 0.9375rem;
  box-shadow: 0px 1px 3px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),
    0px 3px 1px -2px rgb(0 0 0 / 12%);
  min-width: 64px;
  font-weight: 500;
  border-radius: 4px;
  box-sizing: border-box;
  border: none;
  cursor: pointer;
}

.info_btn:hover {
  background-color: #4f7cd5 !important;
}
.right_title {
  height: 30px;
  padding: 15px 0 15px 0;
  border-bottom: 1px solid #f2f2f2;
  font-size: 1.5em;
  font-weight: bold;
  color: #0f7eff;
  margin: 0 auto;
  width: 95%;
}
.whiteBg {
  background: #fff;
  border-radius: 10px;
}
.lineBox {
  display: flex;
  margin: 0 0 20px 0;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.lineTitle {
  margin-top: 15px;
  width: 110px;
}
.strLine {
  width: 85%;
  margin: 0 auto;
  border-top: 1px solid #e5e5e5;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/race/addRace/raceOverview.vue